
const GMAPS_PLACES_TYPES = ['(regions)']
const GMAPS_CONFIG = {
  types: GMAPS_PLACES_TYPES,
  components: {},
}

function getPlacePredictions(ref, google, place, callback) {
  const service = new google.maps.places.AutocompleteService()
  const payload = {
    input: place.name,
    types: GMAPS_PLACES_TYPES,
    offset: place.name.length,
  }

  service.getPlacePredictions(payload, (results) => {
    if (results !== null && results.length) {
      // eslint-disable-next-line new-cap
      const places = google.maps.places.PlacesService(ref)
      const { reference } = results[0]

      places.getDetails({ reference }, callback)
    } else {
      callback(place)
    }
  })
}

export function init(ref, opts, callback) {
  import('@googlemaps/js-api-loader').then(({ Loader }) => {
    const loader = new Loader({ apiKey: window.tpn.keys.gmaps, libraries: ['places'] })

    loader.load().then((google) => {
      const instance = new google.maps.places.Autocomplete(ref, {
        ...GMAPS_CONFIG,
        ...opts,
      })

      google.maps.event.addListener(instance, 'place_changed', () => {
        const place = instance.getPlace()

        if (typeof place.address_components === 'undefined' && place.name) {
          getPlacePredictions(ref, google, place, callback)
        } else {
          callback(place)
        }
      })
    })
  })
}

// eslint-disable-next-line complexity
export function extractCoordinates(result) {
  // eslint-disable-next-line camelcase
  const { formatted_address = '', geometry = {}, name } = result
  const lat = geometry.location && geometry.location.lat() || null
  const lng = geometry.location && geometry.location.lng() || null
  let city = null;
  let state = null;

  for (const component of result.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
    case 'locality': {
      city = component.long_name;
      break;
    }

    case 'administrative_area_level_1': {
      state = component.long_name;
      break;
    }

    default: {
      break;
    }
    }
  }

  return {
    name: formatted_address || name,
    lat,
    lng,
    city,
    state,
  }
}

export function extractState(result) {
  // eslint-disable-next-line camelcase
  const { address_components = [] } = result

  // eslint-disable-next-line camelcase
  const state = address_components.find((component) => component.types.some((type) => type === 'administrative_area_level_1'))

  if (state) {
    return state.long_name
  }

  return ''
}
